

import { ComboList, IComboList } from '@app/core';
import { FormType, IDataGridDefinition, IDataGridElement, IDataGridSource } from 'shared';




// ==============================
// CONTAINER
// ==============================




class SearchForm {
    // idCiclo: number = null;
    // programaEstudios: string = null;
}

export class InfoDatosContainerModel {

    title = 'Base de Datos';

    loading = false;

    comboLists = {
        periodo: new ComboList([]),
        departamento: new ComboList([]),
        condicionLaboral: new ComboList([]),
        nivelAcademico: new ComboList([]),
        provincia: new ComboList([]),
        regimen: new ComboList([]),
        tipoGestion: new ComboList([]),
        distrito: new ComboList([]),
        universidad: new ComboList([]),
    };

    searchForm = new SearchForm();

    gridSource: IDataGridSource<any> = {
        items: [],
        page: 1,
        pageSize: 10,
        total: 0
    };

    gridDefinition: IDataGridDefinition = {
        columns: [
            // { label: 'Programa de estudios', field: 'programaEstudios' },
            // { label: 'Código del programa', field: 'codigoPrograma' },
            // { label: 'Ciclo', field: 'ciclo' },
            // { label: 'Módulos', field: 'modulos' },
            // { label: 'Modalidad de servicio', field: 'modalidadServicio' },
            { label: 'Opciones', field: 'opciones', template: 'tpl-opciones' }
        ]
    };

    rangoSexo = [
        { label: 'Hombres > 14,000', porcentaje: 45 },
        { label: 'Mujeres > 12,000', porcentaje: 55 },
    ];

    rangoEdadEstudiantes = [
        { label: '<30', porcentaje: 5 },
        { label: '30-39', porcentaje: 20 },
        { label: '40-49', porcentaje: 30 },
        { label: '50-59', porcentaje: 30 },
        { label: '60-69', porcentaje: 15 }
    ];


    gridInformacionDetallada: IDataGridElement<any> = {
        loading: false,
        source: {
            items: [],
            page: 1,
            pageSize: 10,
            total: 0
        },
        definition: {
            columns: [
                { label: 'Periodo', field: 'periodo' },
                { label: 'Tipo de información', field: 'categoria' },
                { label: 'Descarga', field: 'formato', template: 'tpl-descarga' }
            ]
        }
    };

    archivoDescarga: {
        archivos: {id:number,formato:string}[],
        periodo: string,
        tipo: string
    }[] = [];

    loadingDescarga = false;
    blobDescarga = [];
    gridFechaCorte: any[] = [];
    gridInstFechaCorte: any[] = [];
}

export const initialState = {
    container: new InfoDatosContainerModel,

}
